import { z } from 'zod';

import { BaseContentSchema, BasePlanCardsDataSchema } from '../common.schema';

const MobileContent = BaseContentSchema.extend({
  subtitle: z.string(),
});

const MobilePlanCardsDataSchema = BasePlanCardsDataSchema.extend({
  content: MobileContent,
});

export type MobilePlanCardDataResponse = z.infer<
  typeof MobilePlanCardsDataSchema
>;

const MobilePlanCardSchema = z.object({
  data: z.array(MobilePlanCardsDataSchema),
});

export type MobilePlanCardSchemaResponse = z.infer<typeof MobilePlanCardSchema>;

export { MobilePlanCardsDataSchema, MobilePlanCardSchema };
